/* global $ */
/*
  auto-scroll.js
  
  A plugin to scroll the window to either a
  specified selector, or #bb-q with a possible
  offset.
  
  e.g. config:

    conf.template: {
      "auto-scroll": {
        "offset": "-30", (This is a px value)
        "custom-selector": "#bb-q",
        "scroller-selector": "#some-parent" (If not provided, 'html' is considered the parent to scroll)
      }
    }

  If no directive is given, default is:

    conf.template: {
      "auto-scroll": {
        "offset": "-30"
        "custom-selector": "#bb-q",
        "scroller-selector": "html"
      }
    }
  
  If scroller-selector is html (default), then the
  position of the custom selector is determined
  relative to the document. Otherwise it will be
  determined reletive to the scroller-selector.

  NB: This probably won't work without:

    conf.core: {
      "scrollToSelectedGroup": false
    }

  auto-scroll also exports it's CONFIG object.
  The object has a setter for props, which will
  fall back to the default if set to "default"
  or if your config fails the sanitycheck.
  You may need this for e.g. if a plugin 
  changes the layout and makes the auto scroll 
  position no longer valid etc...

  Usage example:

  import { CONFIG as scrollconfig } from "[relative path]/plugins/auto-scroll/auto-scroll";
  ...
  if (window.innerWidth <= 943) {
    scrollconfig.props = { selector: ".l-content--left" };
  } else {
    scrollconfig.props = "default";
  }

  Please don't skirt the sanitycheck:
  scrollconfig.props.selector = ...

  Author: Tim Bauwens
  Copyright xxllnc 2023
*/

import { bb } from "$json";
import { has, allPass } from "$json/lib/functional";

const scrollNow = (delay = 500) => {
  window.setTimeout(_e => {
    let config = CONFIG.props;
    let offsetHeight =
      config["scroller-selector"] === "html"
        ? $(config.selector).offset().top
        : $(config.selector).position().top;

    $(config["scroller-selector"]).animate(
      {
        scrollTop: offsetHeight + config.offset
      },
      200
    );
  }, delay);
};

const CONFIG = {
  default: {},
  internal: {},
  get props() {
    return this.internal;
  },
  set props(provided) {
    this.internal =
      provided === "default"
        ? Object.assign({}, this.default)
        : this.sanitycheck(provided);
    // Act now, since the provider probably expects that, unless default reset.
    if (provided != "default") scrollNow(1000);
  },
  sanitycheck: provided => {
    if (typeof provided !== "object") return Object.assign({}, CONFIG.default);
    provided = Object.assign(CONFIG.internal, provided);
    let check = has(CONFIG.props);
    return allPass([
      check("offset") && !isNaN(CONFIG.props.offset),
      check("selector") &&
        document.querySelectorAll(CONFIG.props.selector).length,
      check("scrollerSelector") &&
        document.querySelectorAll(CONFIG.props["scroller-selector"]).length
    ])
      ? provided
      : Object.assign({}, CONFIG.default);
  }
};

export { CONFIG };

((doc, $) => {
  const directives = bb.propFinder(bb.conf, "template")("auto-scroll", {});
  let newprops = {
    "offset": Object.hasOwn(directives, "offset")
      ? Number(directives.offset)
      : -30,
    "selector": Object.hasOwn(directives, "custom-selector")
      ? directives["custom-selector"]
      : "#bb-q",
    "scroller-selector": Object.hasOwn(directives, "scroller-selector")
      ? directives["scroller-selector"]
      : "html"
  };

  CONFIG.default = newprops;
  CONFIG.props = "default";

  $(doc).on("bb:finalHandleData", (_e, data) => {
    if (
      data &&
      data.groups &&
      data.groups[data.groups.length - 1].screenmode !== "addbottom"
    ) {
      if (data.hasprevious) {
        scrollNow();
      } else {
        window.scrollTo(0, 0);
      }
    }
  });
})(document, jQuery);
